import React from 'react';
import '../less/PromotionalOffer.less';

export default function template() {

    const { isMobile, widget } = this.props
    const offer = this.findOfferByEnvironment(widget.data)

    return (
      widget && widget.data && widget.data.length && offer ?
        <div className="info-block" ref={this.blockRef} style={{
          background: offer.background.replace("background: ", "").replace(";", ""),
          paddingTop: isMobile && offer.image_mobile ? '0' : undefined,
        }}>
          {(
            isMobile ? offer.image_mobile : offer.image_desktop) && (
            <img ref={this.imgRef} className="info-block-img" 
              src={isMobile ? offer.image_mobile : offer.image_desktop}
              alt="atb_logo" 
              style={{
                top: isMobile
                  ? offer.top_mobile
                    ? `-${offer.top_mobile}px`
                    : '-136px'
                  : offer.top_desktop
                  ? `-${offer.top_desktop}px`
                  : this.state.isImageOverflow
                  ? 'auto'
                  : '-56px',
                bottom: isMobile
                  ? 'auto'
                  : offer.top_desktop
                  ? 'auto' 
                  : this.state.isImageOverflow
                  ? '0'
                  : 'auto',
              }}>
            </img>
          )}
          {offer.title && 
            <div className="info-block-title" dangerouslySetInnerHTML={{__html: offer.title}} style={{
              marginTop: isMobile && offer.image_mobile
              ? offer.top_mobile
                ? `-${offer.top_mobile}px`
                : '-136px'
              : undefined,
              marginRight: offer.image_desktop && !isMobile ? '262px' : 'auto'
            }}
            ></div>
          }
          {offer.desc_mobile && offer.desc_desktop &&             
            <div className="info-block-text" dangerouslySetInnerHTML={{__html: isMobile ? offer.desc_mobile : offer.desc_desktop}} style={{marginRight: offer.image_desktop && !isMobile ? '262px' : 'auto'}}></div>
          }
        </div>
      : ''
    )
}